/**
 * Apifox scj 文件夹 — feifan-xxl-art /api/art/* 真实接口
 * Header 仅由 http.js 自动附带 Authorization
 */

import { request } from '@/services/http';

/** 附件直传 OSS — GET /attachment/getToken */
export const attachmentService = {
  getToken: (params) =>
    request('/attachment/getToken', { method: 'GET', params }),
};

/** 1. 企业微信认证 — Apifox scj 企业微信认证 Controller */
export const authService = {
  getUserInfoByApiCode: (code) =>
    request('/api/wechatwork/app/auth/getUserInfoByApiCode', {
      method: 'GET',
      skipAuth: true,
      params: { code, app: 'art' },
    }),

  test: () =>
    request('/api/wechatwork/app/auth/test', { method: 'GET', skipAuth: true }),

  test1: () =>
    request('/api/wechatwork/app/auth/test1', { method: 'GET' }),
};

/** 2. CMYK 色板 — Apifox scj CMYK色板 Controller */
export const paletteService = {
  create: (body, params) =>
    request('/api/art/palette/create', { method: 'POST', body, params }),

  list: (params) =>
    request('/api/art/palette/list', { method: 'GET', params }),

  rename: (params) =>
    request('/api/art/palette/rename', { method: 'POST', params }),

  delete: (params) =>
    request('/api/art/palette/delete', { method: 'POST', params }),

  addColor: (body) =>
    request('/api/art/palette/color/add', { method: 'POST', body }),

  listColors: (params) =>
    request('/api/art/palette/color/list', { method: 'GET', params }),

  deleteColor: (params) =>
    request('/api/art/palette/color/delete', { method: 'POST', params }),
};

/** 3. 系统全局配置 — Apifox scj 系统全局配置 Controller */
export const configService = {
  save: (body) =>
    request('/api/art/config/save', { method: 'POST', body }),

  get: (configKey) =>
    request('/api/art/config/get', { method: 'GET', params: { configKey } }),

  getList: () =>
    request('/api/art/config/list', { method: 'GET' }),
};

/** 4. 模板库 — Apifox scj 模板库 Controller */
export const templateService = {
  /** templateFolderType: 1 文件夹，2 文件 */
  queryTemplate: (params) =>
    request('/api/art/template/queryTemplate', { method: 'GET', params }),

  createFolder: (params) =>
    request('/api/art/template/folder/create', { method: 'POST', params }),

  listFolders: (params = {}) =>
    request('/api/art/template/folder/list', { method: 'GET', params }),

  renameFolder: (params) =>
    request('/api/art/template/folder/rename', { method: 'POST', params }),

  sortFolder: (params) =>
    request('/api/art/template/folder/sort', { method: 'POST', params }),

  deleteFolder: (params) =>
    request('/api/art/template/folder/delete', { method: 'POST', params }),

  import: (body, params) =>
    request('/api/art/template/import', { method: 'POST', body, params }), // 文档 18：body.layerJson

  list: (params) =>
    request('/api/art/template/list', { method: 'GET', params }),

  getDetail: (id) =>
    request('/api/art/template/detail', { method: 'GET', params: { id: Number(id) || id } }),

  update: (params) =>
    request('/api/art/template/update', { method: 'POST', params }),

  delete: (params) =>
    request('/api/art/template/delete', { method: 'POST', params }),

  updateAll: (body) =>
    request('/api/art/template/updateAll', { method: 'POST', body }),

  use: (params) =>
    request('/api/art/template/use', { method: 'GET', params }),

  batchMove: (targetFolderId, ids) =>
    request('/api/art/template/batch-move', {
      method: 'POST',
      params: { targetFolderId: targetFolderId != null && targetFolderId !== '' ? (Number(targetFolderId) || targetFolderId) : 0 },
      body: (Array.isArray(ids) ? ids : [ids]).map(id => Number(id) || id),
    }),

  listPageLayers: (templateId) =>
    request('/api/art/template/page-layers', {
      method: 'GET',
      params: { templateId: Number(templateId) || templateId },
    }),

  getLayerJson: (params, options = {}) =>
    request('/api/art/template/getLayerJson', { method: 'GET', params, ...options }),
};

/** 5. 素材库 — Apifox scj 素材库 Controller */
export const materialService = {
  /** materialFolderType: 1 文件夹，2 文件 */
  queryMaterial: (params) =>
    request('/api/art/material/queryMaterial', { method: 'GET', params }),

  createFolder: (params) =>
    request('/api/art/material/folder/create', { method: 'POST', params }),

  listFolders: (params = {}) =>
    request('/api/art/material/queryMaterial', { method: 'GET', params }),

  renameFolder: (params) =>
    request('/api/art/material/folder/rename', { method: 'POST', params }),

  deleteFolder: (params) =>
    request('/api/art/material/folder/delete', { method: 'POST', params }),

  batchDeleteFolders: (ids) =>
    request('/api/art/material/folder/batch-delete', { method: 'POST', body: ids }),

  upload: (body, params) =>
    request('/api/art/material/upload', { method: 'POST', body, params }),

  list: (params) =>
    request('/api/art/material/list', { method: 'GET', params }),

  rename: (params) =>
    request('/api/art/material/rename', { method: 'POST', params }),

  delete: (params) =>
    request('/api/art/material/delete', { method: 'POST', params }),

  updateAll: (body) =>
    request('/api/art/material/updateAll', { method: 'POST', body }),

  batchDelete: (ids) =>
    request('/api/art/material/batch-delete', { method: 'POST', body: ids }),

  batchMove: (targetFolderId, ids) =>
    request('/api/art/material/batch-move', { method: 'POST', params: { targetFolderId }, body: ids }),

  checkAccess: (params) =>
    request('/api/art/material/check-access', { method: 'GET', params }),
};

/** 6. 字体库 */
export const fontService = {
  getPage: (params) =>
    request('/api/art/font/list', { method: 'GET', params }),

  getAll: () =>
    request('/api/art/font/all', { method: 'GET' }),

  upload: (body) =>
    request('/api/art/font/upload', { method: 'POST', body }),

  remove: (id) =>
    request('/api/art/font/delete', { method: 'POST', params: { id: Number(id) || id } }),

  checkMissing: (fontFamilies = []) =>
    request('/api/art/font/check-missing', { method: 'POST', body: fontFamilies }),
};

/** 7. 设计中心模版 — Apifox scj 设计中心模版 Controller（文档 13） */
export const designCenterTemplateService = {
  saveOrUpdate: (body, params, options = {}) =>
    request('/api/art/design-center-template/saveOrUpdate', { method: 'POST', body, params, ...options }),

  create: (body, params) =>
    request('/api/art/design-center-template/create', { method: 'POST', body, params }),

  get: (params) =>
    request('/api/art/design-center-template/get', { method: 'GET', params }),

  getByTemplateId: (params) =>
    request('/api/art/design-center-template/getByTemplateId', { method: 'GET', params }),

  list: (params) =>
    request('/api/art/design-center-template/list', { method: 'GET', params }),

  update: (body, params) =>
    request('/api/art/design-center-template/update', { method: 'POST', body, params }),

  delete: (params) =>
    request('/api/art/design-center-template/delete', { method: 'POST', params }),

  logList: (params) =>
    request('/api/art/design-center-template/log/list', { method: 'GET', params }),

  logCreate: (body, params) =>
    request('/api/art/design-center-template/log/create', { method: 'POST', body, params }),

  logListByCondition: (params) =>
    request('/api/art/design-center-template/log/listByCondition', { method: 'GET', params }),
};

/** 8. 稿件管理 — Apifox scj 稿件管理 Controller */
export const draftService = {
  create: (body) =>
    request('/api/art/draft/create', { method: 'POST', body }),

  list: (params) =>
    request('/api/art/draft/list', { method: 'GET', params }),

  getDetail: (id) =>
    request('/api/art/draft/detail', { method: 'GET', params: { id } }),

  rename: (params) =>
    request('/api/art/draft/rename', { method: 'POST', params }),

  remove: (params) =>
    request('/api/art/draft/delete', { method: 'POST', params }),

  finalize: (params) =>
    request('/api/art/draft/finalize', { method: 'POST', params }),

  listPageLayers: (draftId) =>
    request('/api/art/draft/page-layers', { method: 'GET', params: { draftId } }),

  updateLayerContent: (params) =>
    request('/api/art/draft/layer/update-content', { method: 'POST', params }),

  updateBagPull: (params) =>
    request('/api/art/draft/layer/update-bag-pull', { method: 'POST', params }),

  updateSyncConfig: (params) =>
    request('/api/art/draft/layer/update-sync-config', { method: 'POST', params }),

  autoSave: (params) =>
    request('/api/art/draft/auto-save', { method: 'POST', params }),

  updateUndoStep: (params) =>
    request('/api/art/draft/update-undo-step', { method: 'POST', params }),

  createGroup: (body) =>
    request('/api/art/draft/group/create', { method: 'POST', body }),

  listGroups: (draftId) =>
    request('/api/art/draft/group/list', { method: 'GET', params: { draftId } }),

  renameGroup: (params) =>
    request('/api/art/draft/group/rename', { method: 'POST', params }),

  deleteGroup: (params) =>
    request('/api/art/draft/group/delete', { method: 'POST', params }),

  checkUploadMaxCount: () =>
    request('/api/art/draft/checkUploadMaxCount', { method: 'GET', silentError: true }),

  recordExport: (body) =>
    request('/api/art/draft/export/record', { method: 'POST', body, silentError: true }),
};

/** 9. 设计师任务 — Apifox scj 设计师 Controller */
export const designerTaskApiService = {
  getTaskList: (params) =>
    request('/api/art/designer/task/list', { method: 'GET', params }),

  getTaskCount: (params) =>
    request('/api/art/designer/task/count', { method: 'GET', params }),

  claimTask: (params) =>
    request('/api/art/designer/task/claim', { method: 'POST', params }),

  startTask: (params) =>
    request('/api/art/designer/task/start', { method: 'POST', params }),

  submitTask: (params) =>
    request('/api/art/designer/task/submit', { method: 'POST', params }),

  returnToSales: (body, params) =>
    request('/api/art/designer/task/returnToSales', { method: 'POST', body, params }),

  downloadAttachmentZip: (body) =>
    request('/api/art/designer/downloadAttachmentZip', { method: 'POST', body }),

  getConditions: (params) =>
    request('/api/art/designer/task/conditions', { method: 'GET', params }),
};

/** AI 以图生图 — POST /api/art/ai-image-edit/edit */
export const aiImageEditService = {
  edit: (body, options = {}) =>
    request('/api/art/ai-image-edit/edit', { method: 'POST', body, ...options }),
};

